// extracted by mini-css-extract-plugin
export default {"noDataBlock":"NoData_noDataBlock__N7+6j"};